import { ADD_EDITABLE_PARENT } from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleAddEditableParent<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (action.type !== ADD_EDITABLE_PARENT || !('editableParents' in state)) {
		return state
	}

	return {
		...state,
		editableParents: [...(state.editableParents || []), action.editableParent],
	}
}
